import { FC } from 'react';
import cn from 'clsx';

import { IconProps } from 'types';
import { xmlns } from 'constants/constantsVaribles';
import './Icons.scss';

export const ArrowIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg role="img" className={cn('cb-icon', className)} viewBox="0 0 16 16" xmlns={xmlns} {...rest}>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M-1621-814h4922v2322h-4922z" />
      <path
        className="shape-fill"
        d="M3.59 5.566a.844.844 0 0 1 1.173.005l3.239 3.165 3.235-3.165a.843.843 0 0 1 1.174-.005.79.79 0 0 1 .004 1.136L8.002 11 3.586 6.702a.79.79 0 0 1 .003-1.136Z"
        fill="#0F2643"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export const WelcomeIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-welcome', className)}
    viewBox="0 0 47 48"
    xmlns={xmlns}
    {...rest}
  >
    <g fill="none">
      <path
        fill="#515B6E"
        d="M45.46 16.977h-6.856L28.568 7.124c.149-.505.298-1.06.298-1.667C28.866 2.425 26.48 0 23.5 0s-5.366 2.425-5.366 5.457c0 .606.1 1.162.298 1.667L8.396 16.977H1.54c-.844 0-1.54.707-1.54 1.566v27.89C0 47.294.696 48 1.54 48h43.92c.844 0 1.54-.707 1.54-1.566v-27.89c0-.91-.696-1.567-1.54-1.567ZM23.5 3.133c1.242 0 2.285 1.06 2.285 2.324 0 1.263-1.043 2.324-2.285 2.324-1.242 0-2.285-1.061-2.285-2.324s1.043-2.324 2.285-2.324ZM12.868 16.977l7.353-7.225a5.298 5.298 0 0 0 3.279 1.162 5.298 5.298 0 0 0 3.28-1.162l7.352 7.225H12.868Z"
      />
      <path
        fill="#E3482F"
        d="M14.334 30.274c.702.601 1.054 1.435 1.054 2.501 0 1.067-.35 1.9-1.048 2.501-.698.601-1.525.902-2.482.902-.956 0-1.781-.3-2.475-.902-.694-.6-1.041-1.434-1.041-2.5 0-1.067.347-1.9 1.04-2.502.695-.6 1.52-.901 2.476-.901.957 0 1.782.3 2.476.901Zm-3.783 3.872c.364.339.8.508 1.307.508a1.86 1.86 0 0 0 1.314-.514c.369-.343.553-.798.553-1.365s-.184-1.02-.553-1.358a1.875 1.875 0 0 0-1.314-.508c-.507 0-.943.17-1.307.508-.364.339-.546.791-.546 1.358 0 .567.182 1.024.546 1.371Z"
      />
      <path
        fill="#FED400"
        d="M16.657 38.653v-9.102h1.638v.927c.228-.322.54-.587.933-.794a2.748 2.748 0 0 1 1.301-.311c.838 0 1.54.307 2.108.92.567.614.85 1.441.85 2.482 0 1.016-.298 1.837-.895 2.463-.596.627-1.335.94-2.215.94-.872 0-1.566-.322-2.082-.965v3.44h-1.638Zm4.647-7.21c-.339-.356-.77-.534-1.295-.534-.525 0-.96.178-1.308.533-.347.356-.52.8-.52 1.333 0 .534.173.98.52 1.34.347.36.783.54 1.308.54s.958-.18 1.301-.54c.343-.36.514-.806.514-1.34 0-.533-.173-.977-.52-1.333Z"
      />
      <path
        fill="#D8E5E3"
        d="M30.927 33.169h-4.964c.05.49.237.882.558 1.174.322.292.724.438 1.207.438.787 0 1.38-.393 1.777-1.18l1.231.698c-.609 1.252-1.62 1.879-3.034 1.879-.922 0-1.705-.318-2.348-.952-.644-.635-.965-1.452-.965-2.45 0-1 .326-1.816.977-2.45.652-.636 1.456-.953 2.412-.953.923 0 1.678.303 2.266.908.589.605.883 1.377.883 2.317v.57Zm-3.2-2.552c-.423 0-.793.13-1.11.387a1.962 1.962 0 0 0-.654.972h3.453c-.076-.424-.262-.756-.559-.997-.296-.241-.672-.362-1.13-.362Z"
      />
      <path
        fill="#96B89E"
        d="M38.303 31.607V36h-1.638v-3.72c0-.914-.44-1.37-1.32-1.37-.432 0-.787.168-1.067.507-.279.339-.419.774-.419 1.308V36h-1.637v-6.45h1.637v1.042c.534-.813 1.261-1.219 2.184-1.219.686 0 1.234.205 1.644.616.41.41.616.95.616 1.618Z"
      />
    </g>
  </svg>
);

export const DashboardEmptyStateIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-dashboard-empty-state', className)}
    xmlns={xmlns}
    {...rest}
    viewBox="0 0 48 39"
  >
    <defs>
      <linearGradient id="des1" x1="50%" x2="50%" y1="83.983%" y2="0%">
        <stop offset="0%" stopColor="#67808D" />
        <stop offset="100%" stopColor="#96B8B2" />
      </linearGradient>
      <linearGradient id="des2" x1="50%" x2="50%" y1="83.983%" y2="0%">
        <stop offset="0%" stopColor="#67808D" />
        <stop offset="100%" stopColor="#96B8B2" />
      </linearGradient>
      <linearGradient id="des3" x1="50%" x2="50%" y1="83.983%" y2="0%">
        <stop offset="0%" stopColor="#67808D" />
        <stop offset="100%" stopColor="#96B8B2" />
      </linearGradient>
      <linearGradient id="des4" x1="50%" x2="50%" y1="83.983%" y2="0%">
        <stop offset="0%" stopColor="#67808D" />
        <stop offset="100%" stopColor="#96B8B2" />
      </linearGradient>
      <linearGradient id="des5" x1="50%" x2="50%" y1="83.983%" y2="0%">
        <stop offset="0%" stopColor="#67808D" />
        <stop offset="100%" stopColor="#96B8B2" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(1)">
      <rect width="39" height="2" x="5" y="37" fill="#DFE2E5" rx="1" />
      <g transform="translate(6)">
        <rect width="2.958" height="34" x="25.634" fill="url(#des1)" rx="1.479" />
        <rect width="2.958" height="30" x="32.042" y="4" fill="url(#des2)" rx="1.479" />
        <rect width="2.958" height="16.5" x="19.225" y="17.5" fill="url(#des3)" rx="1.479" />
        <rect width="2.958" height="23.5" x="12.817" y="10.5" fill="url(#des4)" rx="1.479" />
        <rect width="2.958" height="27.5" x="6.408" y="6.5" fill="url(#des5)" rx="1.479" />
        <rect width="2.958" height="23.5" y="10.5" fill="url(#des4)" rx="1.479" />
      </g>
      <g transform="translate(0 5)">
        <path
          fill="#67808D"
          fillRule="nonzero"
          d="M41.616 7.294c-3.184 3.39-7.072 5.623-11.651 6.693-5.278 1.232-8.102.516-12.03-2.051l-.786-.515C15.021 10.04 13.676 9.5 11.745 9.5c-4.248 0-7.723 1.13-10.447 3.385l-.638-.77C3.573 9.703 7.275 8.5 11.745 8.5c2.165 0 3.673.605 5.949 2.082l.789.517c3.716 2.43 6.273 3.078 11.254 1.914 4.334-1.012 8.01-3.105 11.037-6.283l-3.245-2.176 8.75-4.97-1.275 9.982-3.388-2.272Z"
        />
        <circle cx="26.426" cy="14" r="1" fill="#FFF" stroke="#67808D" />
        <circle cx="13.702" cy="9" r="1" fill="#FFF" stroke="#67808D" />
        <circle cx="39.149" cy="9" r="1" fill="#FFF" stroke="#67808D" />
        <circle cx=".979" cy="12.5" r="1" fill="#FFF" stroke="#67808D" />
      </g>
    </g>
  </svg>
);

export const FullArrowIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg role="img" className={cn('cb-icon', className)} viewBox="0 0 24 24" xmlns={xmlns} {...rest}>
    <path
      stroke="#515B6E"
      opacity=".5"
      d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"
    />
  </svg>
);

export const CheckMarkIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg role="img" className={cn('cb-icon', className)} viewBox="0 0 20 18" xmlns={xmlns} {...rest}>
    <path d="m2.303 7 4.7 5L17.094 2" stroke="#0BB5E2" strokeWidth="4" fill="none" />
  </svg>
);

export const TargetIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg role="img" className={cn('cb-icon', className)} viewBox="0 0 20 20" xmlns={xmlns} {...rest}>
    <path
      d="M14.24 5.76l-.84.84a4.8 4.8 0 1 1-4-1.36v1.21a3.6 3.6 0 1 0 3.14 1l-.84.85a2.4 2.4 0 1 1-2.3-.62v1.29c-.36.2-.6.59-.6 1.03 0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2 0-.44-.24-.83-.6-1.03V4H10a6 6 0 1 0 4.24 1.76z"
      fill="#67808D"
      fillRule="nonzero"
    />
  </svg>
);

export const CategoryIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg role="img" className={cn('cb-icon', className)} viewBox="0 0 20 20" xmlns={xmlns} {...rest}>
    <path
      d="M9.17 10.83V15H5v-4.17h4.17zm5.83 0V15h-4.17v-4.17H15zm-1 1h-2.17V14H14v-2.17zM15 5v4.17h-4.17V5H15zM9.17 5v4.17H5V5h4.17z"
      fill="#67808D"
      fillRule="evenodd"
    />
  </svg>
);

export const AddressIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg role="img" className={cn('cb-icon', className)} viewBox="0 0 20 20" xmlns={xmlns} {...rest}>
    <path
      d="M10.03 5a4.04 4.04 0 0 1 4.02 4.05c0 2.68-3.12 5.98-3.87 6.72l-.1.1-.05.06S6 12.09 6 9.05C6 6.81 7.8 5 10.03 5zm0 2.57c-.74 0-1.35.58-1.35 1.29 0 .7.6 1.28 1.35 1.28.74 0 1.34-.57 1.34-1.28 0-.71-.6-1.29-1.34-1.29z"
      fill="#E3482F"
      fillRule="evenodd"
    />
  </svg>
);

export const UpArrow: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon up-arrow', className)}
    viewBox="0 0 21 21"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M18.556 12.5l-1.944 1.945-5.834-5.834-5.833 5.834L3 12.5l7.778-7.778 7.778 7.778z"
      fill="#515B6E"
      fillRule="evenodd"
    />
  </svg>
);

export const SideArrow: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon side-arrow', className)}
    viewBox="0 0 21 21"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M18.556 12.5l-1.944 1.945-5.834-5.834-5.833 5.834L3 12.5l7.778-7.778 7.778 7.778z"
      fill="#515B6E"
      fillRule="evenodd"
    />
  </svg>
);

export const SummaryIcon: FC<IconProps> = ({ className, isActive, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon', 'icon-side-menu', className, isActive && 'active')}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M11 21H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2h6v18zm2 0h6a2 2 0 002-2v-7h-8v9zm8-11V5a2 2 0 00-2-2h-6v7h8z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export const FindingsIcon: FC<IconProps> = ({ className, isActive, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon', 'icon-side-menu', className, isActive && 'active')}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M14.07 5.32a7.04 7.04 0 014.61 4.61c.19.63.76 1.07 1.41 1.07h.04c1 0 1.72-.96 1.43-1.91a10.05 10.05 0 00-6.66-6.66c-.94-.29-1.9.43-1.9 1.43v.04c0 .66.44 1.23 1.07 1.42zm4.61 8.75a7.01 7.01 0 01-4.61 4.61c-.63.19-1.07.76-1.07 1.41v.04c0 1 .96 1.72 1.91 1.43a10.05 10.05 0 006.66-6.66 1.48 1.48 0 00-1.42-1.91h-.05c-.66.01-1.23.45-1.42 1.08zM11 20.11c0-.67-.45-1.24-1.09-1.44a7 7 0 010-13.34c.64-.2 1.09-.77 1.09-1.44v-.01c0-1-.97-1.74-1.93-1.44a10 10 0 000 19.12A1.5 1.5 0 0011 20.11z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export const LogoutIcon: FC<IconProps> = ({ className, isActive, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon', 'icon-side-menu', className, isActive && 'active')}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M11 3a1 1 0 011 1v.12A1 1 0 0111 5H5v14h6a1 1 0 011 1v.12a1 1 0 01-1 .88H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm6 6.21a.5.5 0 01.86-.35l2.79 2.79a.5.5 0 01-.01.7l-2.79 2.79a.5.5 0 01-.85-.35V13h-7a1 1 0 01-1-1v-.12a1 1 0 011-.88h7z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export const OpportunitiesIcon: FC<IconProps> = ({ className, isActive, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon', 'icon-side-menu', className, isActive && 'active')}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M4 16a2 2 0 012 2c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2zm16.07 1c.51 0 .93.45.93 1s-.42 1-.93 1H8.93c-.51 0-.93-.45-.93-1s.42-1 .93-1zM4 10a2 2 0 012 2c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2zm16.07 1c.51 0 .93.45.93 1s-.42 1-.93 1H8.93c-.51 0-.93-.45-.93-1s.42-1 .93-1zM4 4a2 2 0 012 2c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2zm16.07 1c.51 0 .93.45.93 1s-.42 1-.93 1H8.93C8.42 7 8 6.55 8 6s.42-1 .93-1z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export const KnowledgeCenterIcon: FC<IconProps> = ({ className, isActive, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon', 'icon-side-menu', className, isActive && 'active')}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M4.78 13.47v2.69c0 .7.38 1.35 1 1.68l4.78 2.61a1.9 1.9 0 001.84 0l4.78-2.6c.61-.34 1-1 1-1.7v-2.68l-5.78 3.16a1.9 1.9 0 01-1.84 0l-5.78-3.16zm5.78-9.24L2.5 8.63a.96.96 0 000 1.68l8.06 4.4a1.9 1.9 0 001.84 0l7.69-4.2v5.66c0 .52.43.95.95.95.53 0 .96-.43.96-.95v-6.13c0-.36-.2-.67-.5-.85l-9.1-4.96c-.58-.3-1.27-.3-1.84 0z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export const SettingsIcon: FC<IconProps> = ({ className, isActive, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon', 'icon-side-menu', className, isActive && 'active')}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M18.88 12.88a6.45 6.45 0 000-1.76l1.95-1.48a.45.45 0 00.11-.57L19.1 5.95c-.11-.2-.35-.27-.57-.2l-2.3.9c-.48-.36-1-.66-1.56-.88l-.35-2.39a.46.46 0 00-.46-.38h-3.7a.45.45 0 00-.45.38l-.35 2.39a7 7 0 00-1.56.88l-2.3-.9a.47.47 0 00-.57.2L3.08 9.07c-.12.2-.08.44.11.57l1.96 1.48a5.36 5.36 0 00-.02 1.76l-1.96 1.48a.45.45 0 00-.11.57l1.85 3.12c.11.2.35.27.57.2l2.3-.9c.48.36 1 .66 1.56.88l.35 2.39c.05.22.23.38.46.38h3.7c.23 0 .42-.16.45-.38l.35-2.39a6.66 6.66 0 001.56-.88l2.3.9c.22.08.46 0 .57-.2l1.85-3.12a.43.43 0 00-.11-.57l-1.94-1.48zM12 15.38A3.43 3.43 0 018.53 12 3.43 3.43 0 0112 8.62c1.9 0 3.47 1.52 3.47 3.38A3.43 3.43 0 0112 15.38z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export const ContactIcon: FC<IconProps> = ({ className, isActive, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon', 'icon-side-menu', className, isActive && 'active')}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M19.2 5H4.8C3.81 5 3 5.79 3 6.75v10.5c0 .96.81 1.75 1.8 1.75h14.4c.99 0 1.8-.79 1.8-1.75V6.75C21 5.79 20.19 5 19.2 5zm-.55 4.21l-6.19 4.32a.8.8 0 01-.92 0L5.35 9.21a.86.86 0 01-.35-.7c0-.65.64-1.04 1.14-.7L12 11.9l5.86-4.1c.5-.34 1.14.05 1.14.7 0 .28-.13.55-.35.7z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export const TrendsIcon: FC<IconProps> = ({ className, isActive, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon', 'icon-side-menu', className, isActive && 'active')}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M6.4 9.2h.2c.77 0 1.4.63 1.4 1.4v7c0 .77-.63 1.4-1.4 1.4h-.2A1.4 1.4 0 015 17.6v-7c0-.77.63-1.4 1.4-1.4zM12 5c.77 0 1.4.63 1.4 1.4v11.2c0 .77-.63 1.4-1.4 1.4a1.4 1.4 0 01-1.4-1.4V6.4c0-.77.63-1.4 1.4-1.4zm5.6 8c.77 0 1.4.63 1.4 1.4v3.2c0 .77-.63 1.4-1.4 1.4a1.4 1.4 0 01-1.4-1.4v-3.2c0-.77.63-1.4 1.4-1.4z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export const ShareIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon', 'share-icon', className)}
    viewBox="0 0 24 16"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M14.288 1.984v2.075l-.502.14C8.11 5.825 3.434 8.875 1.106 13.583c-.45.91.627 1.814 1.472 1.234 2.31-1.585 5.013-2.568 7.879-3.065a23.846 23.846 0 012.938-.325l.215-.01c.208-.007.4-.011.568-.013h.11v1.964c0 .84 1.004 1.292 1.652.744l6.713-5.684a.97.97 0 00.001-1.486l-6.713-5.7c-.647-.55-1.653-.1-1.653.742zm1.999 2.146l4.183 3.553-4.183 3.542v-.244c.001-.81-.636-1.49-1.465-1.53l-.287-.009c-.323-.005-.747 0-1.236.023-.996.047-2.07.16-3.19.353l-.52.096a23.945 23.945 0 00-4.028 1.14l-.36.144.056-.059c2.43-2.5 5.895-4.243 9.88-5.27a1.534 1.534 0 001.15-1.482V4.13z"
      fill="#102540"
      fillRule="nonzero"
    />
  </svg>
);

export const LogoIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon icon-logo', className)}
    viewBox="0 0 32 33"
    xmlns={xmlns}
    {...rest}
  >
    <defs>
      <radialGradient
        id="a"
        cx="50.01%"
        cy="50.01%"
        r="50.01%"
        fx="50.01%"
        fy="50.01%"
        gradientTransform="matrix(1 0 0 .9697 0 .02)"
      >
        <stop offset="13%" stopColor="#2AF598" />
        <stop offset="100%" stopColor="#08AEEA" />
      </radialGradient>
    </defs>
    <path
      fill="url(#a)"
      fillRule="evenodd"
      d="M9.05.55c.85 0 1.53.7 1.53 1.58 0 .88-.68 1.59-1.53 1.59-.86 0-1.54-.7-1.54-1.59 0-.88.68-1.58 1.54-1.58zM16 .96c.63 0 1.16.52 1.16 1.17 0 .65-.5 1.2-1.13 1.2-.63 0-1.16-.52-1.16-1.17v-.03c0-.65.5-1.17 1.13-1.17zM22.98 0a2.1 2.1 0 012.07 2.13 2.1 2.1 0 01-2.07 2.13 2.1 2.1 0 01-2.07-2.13c0-1.17.91-2.13 2.07-2.13zm6.95.55c.86 0 1.54.7 1.54 1.58 0 .88-.68 1.59-1.54 1.59-.85 0-1.53-.7-1.53-1.59 0-.88.7-1.58 1.53-1.58zm0 28.19A2.1 2.1 0 0132 30.87 2.1 2.1 0 0129.93 33a2.1 2.1 0 01-2.06-2.13 2.1 2.1 0 012.06-2.13zm-27.86 0a2.1 2.1 0 012.06 2.13A2.1 2.1 0 012.07 33 2.1 2.1 0 010 30.87a2.1 2.1 0 012.07-2.13zm6.98.54c.85 0 1.53.7 1.53 1.59 0 .88-.68 1.58-1.53 1.58-.86 0-1.54-.7-1.54-1.58 0-.88.68-1.59 1.54-1.59zm6.95-.3c1 0 1.84.85 1.84 1.89s-.83 1.9-1.84 1.9c-1 0-1.84-.86-1.84-1.9s.83-1.9 1.84-1.9zm6.98.72c.63 0 1.16.52 1.16 1.17 0 .65-.5 1.2-1.16 1.2-.63 0-1.16-.53-1.16-1.17 0-.68.5-1.2 1.16-1.2zm6.95-7.59c.86 0 1.54.7 1.54 1.59 0 .88-.68 1.58-1.54 1.58-.85 0-1.53-.7-1.53-1.58 0-.89.7-1.59 1.53-1.59zm-27.86 0c.85 0 1.53.7 1.53 1.59 0 .88-.68 1.58-1.53 1.58-.86 0-1.54-.7-1.54-1.58 0-.89.68-1.59 1.54-1.59zM16 14.61c1 0 1.84.85 1.84 1.89S17 18.4 16 18.4c-1 0-1.84-.86-1.84-1.9 0-.5.2-.99.53-1.35.35-.34.83-.55 1.31-.55zm6.98 0c1 0 1.84.85 1.84 1.89s-.83 1.9-1.84 1.9c-1 0-1.84-.86-1.84-1.9 0-.5.2-.99.53-1.35.35-.34.8-.55 1.31-.55zm-12.65 7.74c1.59 1.63 3.05 1.04 4.56-.16a1.8 1.8 0 012.24 0c1.97 1.56 2.75 1.56 4.74 0 .8-.65 1.97-.5 2.57.34.63.83.48 2.03-.33 2.65a1.8 1.8 0 01-2.24 0c-1.96-1.56-2.75-1.56-4.74 0a1.8 1.8 0 01-2.24 0c-1.96-1.56-2.75-1.56-4.74 0a1.8 1.8 0 01-2.57-.37c-.5-.67-.5-1.6 0-2.28 1.52-2.03 1.52-2.83 0-4.89-.5-.67-.5-1.63 0-2.3 1.52-2.04 1.52-2.84 0-4.9-.6-.83-.45-2.02.36-2.64a1.77 1.77 0 012.21 0c1.97 1.55 2.78 1.55 4.74 0a1.8 1.8 0 012.24 0c1.97 1.55 2.75 1.55 4.74 0 .8-.65 1.97-.5 2.57.33.63.83.48 2.03-.33 2.65a1.8 1.8 0 01-2.24 0c-1.96-1.56-2.75-1.56-4.74 0a1.8 1.8 0 01-2.24 0c-1.51-1.2-2.95-1.82-4.56-.15-1.61 1.66-1 3.14.15 4.7.5.68.5 1.64 0 2.31-1.16 1.59-1.74 3.07-.15 4.7zm19.6-7.75c1.01 0 1.84.86 1.84 1.9s-.83 1.9-1.84 1.9c-1 0-1.84-.86-1.84-1.9s.84-1.9 1.84-1.9zm-27.86.73c.63 0 1.16.52 1.16 1.17 0 .65-.5 1.2-1.14 1.2-.63 0-1.16-.52-1.16-1.17-.02-.68.5-1.2 1.14-1.2zm27.86-7.2c.63 0 1.16.52 1.16 1.2a1.16 1.16 0 11-2.32 0c.03-.68.53-1.2 1.16-1.2zM2.07 7.2a2.1 2.1 0 012.06 2.13 2.1 2.1 0 01-2.06 2.13A2.1 2.1 0 010 9.33C0 8.13.93 7.2 2.07 7.2zm0-6.97c1 0 1.84.86 1.84 1.9s-.84 1.9-1.84 1.9c-1.01 0-1.84-.86-1.84-1.9S1.06.23 2.07.23z"
    />
  </svg>
);

export const NoResponseIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon icon-no-response', className)}
    viewBox="0 0 34 28"
    xmlns={xmlns}
    {...rest}
  >
    <g fillRule="nonzero" fill="none">
      <path
        d="M17.84 11.15c.75.57 1.65.85 2.55.85.76 0 1.5-.14 2.1-.42V22H15v-6.25l-6.02.05V22H1.45V11.58c.6.28 1.35.42 2.1.42 1.06 0 2.11-.28 2.86-.85a5.25 5.25 0 005.72 0 5.25 5.25 0 005.7 0zM21 0c.74 0 1.5.62 1.64 1.24L24 6.97c0 2.33-1.63 3.88-3.56 3.88a3.33 3.33 0 01-2.81-1.55c-.74.93-1.63 1.55-2.81 1.55A3.33 3.33 0 0112 9.3c-.74.93-1.63 1.55-2.81 1.55A3.33 3.33 0 016.37 9.3c-.74.93-1.63 1.55-2.81 1.55C1.63 10.85-.05 9.3 0 6.97l1.33-5.73C1.48.46 2.21 0 2.96 0z"
        fill="#E3482F"
      />
      <g transform="translate(18 12)">
        <ellipse fill="#FFF" cx="7.93" cy="7.81" rx="7.93" ry="7.81" />
        <circle fill="#E3482F" cx="7.76" cy="7.74" r="6" />
        <path
          d="M10.06 4.7L11.1 5.7 9.02 7.75l2.06 2.02-1.03 1.02-2.06-2.03-2.07 2.04L4.9 9.79l2.07-2.04L4.9 5.73 5.94 4.7l2.05 2.02 2.07-2.03z"
          fill="#FFF"
        />
      </g>
    </g>
  </svg>
);

export const LogoTitleIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon icon-logo icon-title-logo', className)}
    viewBox="0 0 122 33"
    xmlns={xmlns}
    {...rest}
  >
    <defs>
      <radialGradient
        id="a"
        cx="50%"
        cy="50%"
        r="50%"
        fx="50%"
        fy="50%"
        gradientTransform="matrix(1 0 0 .9697 0 0)"
      >
        <stop offset="13%" stopColor="#2AF598" />
        <stop offset="100%" stopColor="#08AEEA" />
      </radialGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="url(#a)"
        d="M9 .5c.9 0 1.6.7 1.6 1.6 0 1-.7 1.6-1.6 1.6-.8 0-1.5-.7-1.5-1.6 0-.9.7-1.6 1.5-1.6zm7 .5c.6 0 1.2.5 1.2 1.1 0 .7-.5 1.2-1.2 1.2-.6 0-1.1-.5-1.1-1.1 0-.7.5-1.2 1.1-1.2zm7-1c1.1 0 2 1 2 2.1 0 1.2-.9 2.2-2 2.2-1.2 0-2-1-2-2.2A2 2 0 0123 0zm7 .5c.8 0 1.5.7 1.5 1.6 0 1-.7 1.6-1.6 1.6-.8 0-1.5-.7-1.5-1.6 0-.9.7-1.6 1.5-1.6zm0 28.2c1 0 2 1 2 2.2 0 1.1-1 2.1-2 2.1-1.2 0-2.1-1-2.1-2.1 0-1.2.9-2.2 2-2.2zm-28 0c1.2 0 2.1 1 2.1 2.2 0 1.1-.9 2.1-2 2.1C.9 33 0 32 0 30.9c0-1.2 1-2.2 2-2.2zm7 .6c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6-.8 0-1.5-.7-1.5-1.6 0-1 .7-1.6 1.5-1.6zm7-.3c1 0 1.8.8 1.8 1.9 0 1-.8 1.9-1.8 1.9s-1.8-.9-1.8-2c0-1 .8-1.8 1.8-1.8zm7 .7c.6 0 1.1.5 1.1 1.2 0 .6-.5 1.2-1.1 1.2-.7 0-1.2-.6-1.2-1.2 0-.7.5-1.2 1.2-1.2zm7-7.6c.8 0 1.5.7 1.5 1.6 0 .9-.7 1.6-1.6 1.6-.8 0-1.5-.7-1.5-1.6 0-.9.7-1.6 1.5-1.6zm-28 0c1 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.5 1.6-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6zm14-7.5c1 0 1.8.9 1.8 1.9 0 1-.8 1.9-1.8 1.9s-1.8-.9-1.8-1.9c0-.5.2-1 .5-1.4a2 2 0 011.3-.5zm7 0c1 0 1.8.9 1.8 1.9 0 1-.8 1.9-1.8 1.9s-1.9-.9-1.9-1.9c0-.5.2-1 .6-1.4.3-.3.8-.5 1.3-.5zm-12.7 7.7c1.6 1.7 3 1 4.6-.1.6-.5 1.6-.5 2.2 0 2 1.5 2.8 1.5 4.8 0 .8-.7 2-.5 2.5.3.7.9.5 2-.3 2.7-.6.5-1.6.5-2.2 0-2-1.6-2.8-1.6-4.8 0-.6.5-1.6.5-2.2 0-2-1.6-2.8-1.6-4.7 0-.9.6-2 .4-2.6-.4a2 2 0 010-2.3c1.5-2 1.5-2.8 0-4.9a2 2 0 010-2.3c1.5-2 1.5-2.8 0-4.9a2 2 0 01.3-2.6c.7-.5 1.6-.5 2.3 0 2 1.6 2.7 1.6 4.7 0 .6-.5 1.6-.5 2.2 0 2 1.6 2.8 1.6 4.8 0 .8-.7 2-.5 2.5.3.7.9.5 2-.3 2.7-.6.5-1.6.5-2.2 0-2-1.6-2.8-1.6-4.8 0-.6.5-1.6.5-2.2 0-1.5-1.2-3-1.8-4.6-.2-1.6 1.7-1 3.2.2 4.7a2 2 0 010 2.3c-1.2 1.6-1.8 3.1-.2 4.7zM30 14.6c1 0 1.9.9 1.9 1.9 0 1-.9 1.9-1.9 1.9-1 0-1.8-.9-1.8-1.9 0-1 .8-1.9 1.8-1.9zm-27.8.7c.6 0 1.1.6 1.1 1.2s-.5 1.2-1.1 1.2c-.6 0-1.2-.5-1.2-1.2 0-.6.5-1.2 1.2-1.2zm27.8-7.2c.7 0 1.2.6 1.2 1.2a1.2 1.2 0 11-2.3 0c0-.6.5-1.2 1.1-1.2zM2.1 7.2c1.1 0 2 1 2 2.1 0 1.2-.9 2.2-2 2.2-1.2 0-2.1-1-2.1-2.2a2 2 0 012-2.1zm0-7c1 0 1.8.9 1.8 2C4 3.1 3.1 4 2.1 4S.2 3.2.2 2.1c0-1 .9-1.9 1.9-1.9z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M57.2 31a13.1 13.1 0 01-13-11.6c-.4-3.2-.2-6.3 1.3-9.2 2-3.8 5-6 9.1-6.9A13 13 0 0166.2 6a8.6 8.6 0 012.8 4.4c.4 1.5 0 2.8-1.3 3.4-1.4.7-3 .1-3.6-1.2a8.5 8.5 0 00-3-3.5 7.6 7.6 0 00-11.2 5.3c-.6 2.9-.4 5.7 1.2 8.2 2.7 4.2 8.6 4 11 1.6.6-.5 1-1.2 1.5-1.8.3-.4.4-1 .7-1.3.9-1.2 2.1-1.5 3.5-1 1.1.6 1.7 1.7 1.3 3.2a9.3 9.3 0 01-4.7 6 13.2 13.2 0 01-7.2 1.7zm60.4-5v2.3c0 1.7-1 2.7-2.5 2.7-1.6 0-2.6-1-2.7-2.6V26h-11.3a4 4 0 01-2-.6c-1.3-.8-1.6-2.8-.5-4.1l3.1-3.7L112 6c.3-.4.6-.8 1-1 1-1 2-1 3-.6s1.8 1.4 1.7 2.5V21h2c1.7.1 2.7 1.4 2.3 3.1-.2 1-1 1.8-2.2 1.8h-2zm-4.8-13.7l-8 9.4h8v-9.4zm-17.6 6c-.8-.9-2-1.6-3.1-2l.3-.2c3.2-2 3.3-5.6 2-8C93 5.5 90.7 4.3 88 4.2H75.5c-1.2 0-2.2.5-2.6 1.7a5 5 0 00-.2 1.5v1.9H87.3c1.5.3 2.2 1.1 2.2 2.6 0 1.4-1 2.6-2.4 2.6H72.7v13.2c0 2.3 1 3.3 3.2 3.3h12.6c1 0 2-.2 3-.5 5.9-2 6.4-9 3.7-12.1zm-6.8 6.8h-10v-5.7h10.1c1.7.3 2.5 1.2 2.5 2.8 0 1.6-.9 2.6-2.6 2.9z"
      />
    </g>
  </svg>
);

export const MessageIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon icon-reasons', className)}
    viewBox="0 0 35 31"
    xmlns={xmlns}
    {...rest}
  >
    <g fillRule="nonzero" fill="none">
      <path
        d="M32.98 0H2.02C.874 0 0 .916 0 2.114v28.181c0 .656.728.929 1.144.494l5.183-5.425H32.98c1.144 0 2.019-.916 2.019-2.114V2.114C35 .916 34.125 0 32.98 0zm.674 23.25c0 .423-.27.705-.673.705H6.058a.599.599 0 00-.471.21l-4.24 4.44V2.113c0-.423.268-.705.672-.705h30.962c.404 0 .673.282.673.705V23.25z"
        fill="#67808D"
      />
      <path fill="#E3482F" d="M7 12h19.865v1H7z" />
      <path fill="#E5BEC0" d="M7 16h13.243v1H7z" />
      <path fill="#00397D" d="M7 8h19.865v1H7z" />
    </g>
  </svg>
);

export const WhiteMessageIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('cb-icon icon-reasons', className)}
    viewBox="0 0 35 31"
    xmlns={xmlns}
    {...rest}
  >
    <g fill="#FFF" fillRule="nonzero">
      <path d="M32.98 0H2.02C.874 0 0 .916 0 2.114v28.181c0 .656.728.929 1.144.494l5.183-5.425H32.98c1.144 0 2.019-.916 2.019-2.114V2.114C35 .916 34.125 0 32.98 0zm.674 23.25c0 .423-.27.705-.673.705H6.058a.599.599 0 00-.471.21l-4.24 4.44V2.113c0-.423.268-.705.672-.705h30.962c.404 0 .673.282.673.705V23.25z" />
      <path d="M8 12h19.865v1H8zM8 16h13.243v1H8zM8 8h19.865v1H8z" />
    </g>
  </svg>
);

export const CompleteIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-empty-list', className)}
    viewBox="0 0 83 88"
    xmlns={xmlns}
    {...rest}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0v56.97a9 9 0 0 0 2.14 5.82l.04.04c.24.29.5.55.77.8l20.32 21.04a9.08 9.08 0 0 0 6.7 2.93H64.8V0H0zm63.19 85.99H29.96a7.47 7.47 0 0 1-7.47-7.45V64.41H9.09c-1.9 0-3.71-.72-5.1-2l-.6-.64a7.4 7.4 0 0 1-1.78-4.82V1.61H63.2v84.38z"
        fill="#00397D"
        fillRule="nonzero"
      />
      <path fill="#899FB1" d="M9.6 9.6h45.6v4.8H9.6z" />
      <path fill="#FED400" d="M9.6 20.4h45.6v4.8H9.6z" />
      <path fill="#E3482F" d="M9.6 32.4h45.6v4.8H9.6z" />
      <path fill="#00397D" d="M9.6 43.2h45.6V48H9.6z" />
      <g transform="translate(43.2 15.6)">
        <circle fill="#D8E5E3" fillRule="nonzero" cx="19.8" cy="19.8" r="19.8" />
        <circle fill="#96B89E" fillRule="nonzero" cx="19.8" cy="19.8" r="15.4" />
        <path stroke="#FFF" strokeWidth="3.6" d="M13.98 18.64l4.44 4.65 9.53-9.31" />
      </g>
    </g>
  </svg>
);

export const FilteredIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-empty-list', className)}
    viewBox="0 0 83 88"
    xmlns={xmlns}
    {...rest}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M57.076 24.4 36.845 49.777v19.21l-7.98 6.124a2.2 2.2 0 0 1-3.539-1.745V49.78L7.791 27.979A2.2 2.2 0 0 1 9.505 24.4h47.571Z"
        stroke="#515B6E"
        strokeWidth="2"
      />
      <g transform="translate(35.8 11)" fillRule="nonzero">
        <circle fill="#FFF" cx="20.4" cy="20.4" r="20.4" />
        <circle fill="#E3482F" cx="20.4" cy="20.4" r="15.867" />
        <path fill="#FFF" d="M32.39 18.53v3.74H9.066v-3.74z" />
      </g>
    </g>
  </svg>
);

export const NoResultIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-empty-list', className)}
    viewBox="0 0 83 88"
    xmlns={xmlns}
    {...rest}
  >
    <g fillRule="nonzero" fill="none">
      <path
        d="M0 0v56.97a9 9 0 0 0 2.14 5.82l.04.04c.24.29.5.55.77.8l20.32 21.04a9.08 9.08 0 0 0 6.7 2.93H64.8V0H0zm63.19 85.99H29.96a7.47 7.47 0 0 1-7.47-7.45V64.41H9.09c-1.9 0-3.71-.72-5.1-2l-.6-.64a7.4 7.4 0 0 1-1.78-4.82V1.61H63.2v84.38z"
        fill="#00397D"
      />
      <circle fill="#FFF" cx="63.55" cy="35.65" r="19.55" />
      <circle fill="#E3482F" cx="63.55" cy="35.65" r="15.21" />
      <path fill="#FFF" d="M75.04 33.86v3.58H52.69v-3.58z" />
    </g>
  </svg>
);

export const PlayIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-play', className)}
    viewBox="0 0 128 128"
    xmlns={xmlns}
    xmlnsXlink={`${xmlns}/xlink`}
    {...rest}
  >
    <defs>
      <filter x="-24%" y="-18%" width="148%" height="148%" filterUnits="objectBoundingBox" id="a">
        <feOffset dy="6" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="7" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feComposite
          in="shadowBlurOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.197350543 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <circle id="b" cx="50" cy="50" r="50" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(14 8)">
        <use fill="#000" filter="url(#a)" xlinkHref="#b" />
        <use fillOpacity=".698" fill="#FFF" xlinkHref="#b" />
      </g>
      <path
        d="M80.643 59.098 57.53 73.544a1 1 0 0 1-1.53-.848V43.804a1 1 0 0 1 1.53-.848l23.113 14.446a1 1 0 0 1 0 1.696Z"
        fill="#00397D"
      />
    </g>
  </svg>
);

export const FilterIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-filter', className)}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      fill="none"
      stroke="#3F5066"
      strokeWidth="2"
      d="M18.79 5a1.1 1.1 0 0 1 .84 1.8l-4.82 5.76v4.79l-2.83 2.34a1.1 1.1 0 0 1-1.75-.89v-6.24L5.37 6.81a1.1 1.1 0 0 1 .59-1.78Z"
    />
    <circle cx="18" cy="6" r="3.5" fill="none" stroke="none" />
  </svg>
);

export const CloseIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-close', className)}
    viewBox="0 0 20 20"
    xmlns={xmlns}
    {...rest}
  >
    <path
      fill="#FFFFFF"
      fillRule="evenodd"
      d="M5.76 4.34 10 8.6l4.24-4.25 1.42 1.42L11.4 10l4.25 4.24-1.42 1.42L10 11.4l-4.24 4.25-1.42-1.42L8.6 10 4.34 5.76l1.42-1.42Z"
    />
  </svg>
);

export const StoreGrayIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="36"
    height="36"
    className={cn('icon-store-gray', className)}
    viewBox="0 0 31 22"
    xmlns={xmlns}
    {...rest}
  >
    <g id="icon-store-gray" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g id="Illustration/store/gray" fillRule="nonzero" transform="translate(-2 -6)">
        <path
          fill="#899FB1"
          d="M19.13 16.7c.72.55 1.58.82 2.45.82.72 0 1.44-.14 2.02-.4v10h-7.22v-6l-5.77.05v5.95H3.39v-10c.58.26 1.3.4 2.02.4a4.7 4.7 0 0 0 2.75-.81 5.04 5.04 0 0 0 5.48 0 5.04 5.04 0 0 0 5.49 0ZM22.16 6c.71 0 1.43.6 1.57 1.19l1.31 5.5c0 2.23-1.56 3.72-3.41 3.72a3.2 3.2 0 0 1-2.7-1.49c-.72.9-1.57 1.5-2.7 1.5a3.2 3.2 0 0 1-2.7-1.5c-.72.9-1.57 1.5-2.71 1.5a3.2 3.2 0 0 1-2.7-1.5c-.71.9-1.57 1.5-2.7 1.5-1.85 0-3.47-1.5-3.42-3.73l1.28-5.5C3.42 6.45 4.13 6 4.84 6Z"
        />
        <ellipse cx="26.55" cy="23.78" fill="#FFF" rx="7.27" ry="7.22" />
        <circle cx="26.66" cy="23.92" r="5.76" fill="#899FB1" />
        <path fill="#FFF" d="M26.01 19.62h1.32v8.32h-1.32z" transform="rotate(90 26.67 23.78)" />
      </g>
    </g>
  </svg>
);

export const StoreGreenIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="36"
    height="36"
    className={cn('icon-store-green', className)}
    viewBox="0 0 31 22"
    xmlns={xmlns}
    {...rest}
  >
    <g id="icon-store-green" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g id="Illustration/store/green" fillRule="nonzero" transform="translate(-2 -5)">
        <path
          fill="#96B89E"
          d="M19.35 15.85c.73.55 1.61.82 2.49.82.73 0 1.46-.13 2.05-.4V26.4h-7.32v-6.08l-5.85.05v6.03h-7.3V16.26c.58.28 1.3.41 2.04.41a4.7 4.7 0 0 0 2.78-.82 5.1 5.1 0 0 0 5.55 0 5.1 5.1 0 0 0 5.56 0ZM22.43 5c.72 0 1.45.6 1.6 1.2l1.31 5.56v.02c0 2.26-1.58 3.77-3.45 3.77-1.16 0-2.16-.6-2.74-1.5-.72.9-1.59 1.5-2.74 1.5-1.15 0-2.16-.6-2.74-1.5-.72.9-1.58 1.5-2.73 1.5-1.16 0-2.17-.6-2.74-1.5-.72.9-1.59 1.5-2.74 1.5-1.87 0-3.51-1.5-3.46-3.77v-.02c.06-.21.49-2.06 1.3-5.55C3.44 5.45 4.15 5 4.87 5Z"
        />
        <ellipse cx="26.89" cy="24.34" fill="#FFF" rx="7.38" ry="7.66" />
        <circle cx="26.98" cy="24.21" r="5.84" fill="#96B89E" />
      </g>
    </g>
  </svg>
);

export const StoreRedIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="36"
    height="36"
    className={cn('icon-store-red', className)}
    viewBox="0 0 31 22"
    xmlns={xmlns}
    {...rest}
  >
    <g id="icon-store-red" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g id="Illustration/store/red" fillRule="nonzero" transform="translate(-2 -5)">
        <path
          fill="#E3482F"
          d="M18.79 15.5a4 4 0 0 0 2.4.8c.71 0 1.42-.14 1.98-.4v9.8H16.1v-5.88l-5.66.05v5.83H3.37v-9.8c.56.26 1.27.4 1.98.4.99 0 1.98-.27 2.69-.8a4.94 4.94 0 0 0 5.37 0 4.94 4.94 0 0 0 5.38 0ZM21.77 5c.7 0 1.4.58 1.54 1.17l1.28 5.4c0 2.18-1.54 3.64-3.35 3.64-1.11 0-2.1-.59-2.65-1.46-.7.87-1.53 1.46-2.65 1.46a3.16 3.16 0 0 1-2.65-1.46c-.7.87-1.53 1.46-2.65 1.46A3.13 3.13 0 0 1 8 13.75c-.7.87-1.54 1.46-2.65 1.46-1.82 0-3.4-1.46-3.35-3.65l1.26-5.4C3.4 5.45 4.08 5 4.78 5Z"
        />
        <ellipse cx="26.41" cy="23.65" fill="#FFF" rx="7.47" ry="7.35" />
        <circle cx="26.25" cy="23.57" r="5.65" fill="#E3482F" />
        <path
          fill="#FFF"
          d="m28.4 20.71.98.96-1.95 1.91 1.94 1.91-.98.96-1.93-1.91-1.95 1.92-.96-.96 1.94-1.91-1.94-1.9.98-.97 1.93 1.91 1.95-1.92Z"
        />
      </g>
    </g>
  </svg>
);

export const StoreYellowIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="36"
    height="36"
    className={cn('icon-store-yellow', className)}
    viewBox="0 0 32 27"
    xmlns={xmlns}
    {...rest}
  >
    <g id="icon-store-yellow" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g id="Illustration/store/yellow" fillRule="nonzero">
        <path
          fill="#FED400"
          d="M18.37 14.86c.74.55 1.61.83 2.5.83.73 0 1.46-.14 2.04-.41v10.15H15.6v-6.1l-5.85.06v6.04H2.4V15.28c.59.27 1.32.4 2.05.4 1.03 0 2.05-.27 2.79-.82a5.11 5.11 0 0 0 5.56 0 5.11 5.11 0 0 0 5.56 0ZM21.46 4c.72 0 1.44.6 1.59 1.2l1.32 5.59c0 2.26-1.58 3.77-3.46 3.77-1.15 0-2.16-.6-2.74-1.5-.72.9-1.59 1.5-2.74 1.5-1.15 0-2.16-.6-2.74-1.5-.72.9-1.59 1.5-2.74 1.5-1.16 0-2.17-.6-2.74-1.5-.73.9-1.6 1.5-2.75 1.5-1.87 0-3.51-1.5-3.46-3.77l1.3-5.58C2.44 4.45 3.16 4 3.88 4Z"
        />
        <ellipse cx="26.74" cy="24.05" fill="#FFF" rx="7.67" ry="7.95" />
        <circle cx="26.61" cy="23.71" r="5.84" fill="#FED400" />
        <path fill="#FFF" d="M25.15 20.43h1.41v3.75h-1.41z" transform="rotate(180 25.86 22.3)" />
        <path fill="#FFF" d="M27.1 22.16h1.46v5.37H27.1z" transform="rotate(90 27.83 24.84)" />
      </g>
    </g>
  </svg>
);

export const SearchIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-search', className)}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      fill="#3F5066"
      d="M10 4a6 6 0 0 1 4.9 9.5l5.5 5.5-1.4 1.4-5.5-5.5A6 6 0 1 1 10 4Zm0 2a4 4 0 1 0 2.3 7.2l1-.9A4 4 0 0 0 10 6Z"
    />
  </svg>
);

export const SortDescIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-sort', className)}
    viewBox="0 0 20 20"
    xmlns={xmlns}
    {...rest}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M-1590-1034h4922v2322h-4922z" />
      <path
        className="fill-path"
        fill="#A3A8B2"
        fillRule="evenodd"
        d="M14.7 4v9l1.9-1.8 1.4 1.5-4.3 4.3-4.2-4.3 1.4-1.5 1.8 1.8V4h2ZM5.1 14.5V16H1v-1.4h4.1Zm2-3.5v1.4H1V11h6.2Zm2.1-3.5v1.4H1V7.5h8.2Zm0-3.5v1.4H1V4h8.2Z"
      />
    </g>
  </svg>
);

export const SortAscIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-sort', className)}
    viewBox="0 0 20 20"
    xmlns={xmlns}
    {...rest}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M-1590-1034h4922v2322h-4922z" />
      <path
        className="fill-path"
        fill="#A3A8B2"
        d="M15.3 4v9l1.8-1.8 1.4 1.5-4.3 4.3-4.2-4.3 1.4-1.5 1.8 1.9V4h2.1ZM9 14.6V16H1v-1.4h8ZM9 11v1.4H1V11h8ZM7 7.5V9H1V7.5h6ZM5 4v1.4H1V4h4Z"
      />
    </g>
  </svg>
);

export const PrintIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-print', className)}
    viewBox="0 0 24 24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      fill="#3F5066"
      d="M15.3 3c1 0 1.6.8 1.7 1.7V7h1.1C19.6 7 21 8.2 21 9.6v5.6c0 1.5-1.2 2.7-2.7 2.8H18v2c0 .6-.4 1-1 1H7a1 1 0 0 1-1-1v-2h-.1A2.8 2.8 0 0 1 3 15.4V9.8C3 8.3 4.2 7.1 5.7 7H7V4.9C7 3.9 7.7 3 8.6 3h6.7Zm.7 12H8v4h8v-4Zm2.1-6H6c-.5 0-.8.3-.9.7v5.5c0 .4.3.7.8.8H6v-2c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v2h.1c.5 0 .8-.3.9-.7V9.8c0-.4-.3-.7-.8-.8ZM15 5H9v2h6V5Z"
    />
  </svg>
);

export const CalendarIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    className={cn('icon-print', className)}
    width="24"
    height="24"
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M19.8 5.522h-2.032V4.2a.2.2 0 0 0-.2-.2h-1.776a.2.2 0 0 0-.2.2v1.322H8.408V4.2a.2.2 0 0 0-.2-.2H6.432a.2.2 0 0 0-.2.2v1.322H4.2a.2.2 0 0 0-.2.2V19.8c0 .11.09.2.2.2h15.6a.2.2 0 0 0 .2-.2V5.722a.2.2 0 0 0-.2-.2Zm-9.16 8.529v-2.378h2.72v2.378h-2.72Zm2.72.4v2.378h-2.72v-2.378h2.72ZM4.4 11.673h2.72v2.378H4.4v-2.378Zm3.12 0h2.72v2.378H7.52v-2.378Zm6.24 0h2.72v2.378h-2.72v-2.378Zm3.12 0h2.72v2.378h-2.72v-2.378Zm2.72-.4h-2.72V8.936h2.72v2.337Zm-3.12 0h-2.72V8.936h2.72v2.337Zm-3.12 0h-2.72V8.936h2.72v2.337Zm-3.12 0H7.52V8.936h2.72v2.337Zm-3.12 0H4.4V8.936h2.72v2.337ZM4.4 14.45h2.72v2.378H4.4v-2.378Zm3.12 0h2.72v2.378H7.52v-2.378Zm2.72 2.778V19.6H7.52v-2.37h2.72Zm.4 0h2.72V19.6h-2.72v-2.37Zm3.12 0h2.72V19.6h-2.72v-2.37Zm0-.4v-2.378h2.72v2.378h-2.72Zm3.12-2.378h2.72v2.378h-2.72v-2.378ZM15.992 4.4h1.376v2.415h-1.376V4.4Zm-9.36 0h1.376v2.415H6.632V4.4Zm-.4 1.522v1.093c0 .11.09.2.2.2h1.776a.2.2 0 0 0 .2-.2V5.922h7.184v1.093c0 .11.09.2.2.2h1.776a.2.2 0 0 0 .2-.2V5.922H19.6v2.614H4.4V5.922h1.832ZM4.4 17.23h2.72V19.6H4.4v-2.37ZM16.88 19.6v-2.37h2.72v2.37h-2.72Z"
      fill="#0BB5E2"
      fillRule="nonzero"
    />
  </svg>
);

export const ThreeDots: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="36"
    height="36"
    className={cn('icon-more', className)}
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M17.871 24c1.097 0 1.986.895 1.986 2s-.89 2-1.986 2a1.993 1.993 0 0 1-1.985-2c0-1.105.889-2 1.985-2Zm0-8c1.097 0 1.986.895 1.986 2s-.89 2-1.986 2a1.993 1.993 0 0 1-1.985-2c0-1.105.889-2 1.985-2Zm0-8c1.097 0 1.986.895 1.986 2s-.89 2-1.986 2a1.993 1.993 0 0 1-1.985-2c0-1.105.889-2 1.985-2Z"
      fill="#515B6E"
      fillRule="evenodd"
      opacity=".5"
    />
  </svg>
);

export const PositiveArrowIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="20"
    height="20"
    className={cn('cb-icon icon-positive-arrow', className)}
    xmlns={xmlns}
    {...rest}
  >
    <g fill="#4EC003" fillRule="evenodd">
      <rect opacity=".3" width="20" height="20" rx="10" />
      <path d="m10 4 6 9H4z" />
    </g>
  </svg>
);

export const NegativeArrowIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="20"
    height="20"
    className={cn('cb-icon icon-negative-arrow', className)}
    xmlns={xmlns}
    {...rest}
  >
    <g fill="#E3482F" fillRule="evenodd">
      <rect fillOpacity=".3" width="20" height="20" rx="10" />
      <path d="m10 15 6-9H4z" />
    </g>
  </svg>
);

export const ResponseRateIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    className={cn('cb-icon icon-response_rate', className)}
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M9.77212 8.30117c-.16615 0-.30263-.02947-.40944-.08842-.10681-.05895-.16022-.13427-.16022-.22597v-.786c0-.0917.05341-.16702.16022-.22597s.2433-.08842.40944-.08842h10.65822c.16615 0 .30263.02947.40944.08842.10681.05895.16022.13427.16022.22597v.786c0 .0917-.0534.16702-.16022.22597-.1068.05895-.24329.08842-.40944.08842H9.77212Zm0 4.24437c-.16615 0-.30263-.02947-.40944-.08842-.10681-.05895-.16022-.13428-.16022-.22598v-.78599c0-.0917.05341-.16702.16022-.22597s.2433-.08843.40944-.08843h10.65822c.16615 0 .30263.02948.40944.08843.10681.05895.16022.13427.16022.22597v.786c0 .0917-.0534.16702-.16022.22597-.1068.05895-.24329.08842-.40944.08842H9.77212Zm0 4.24437c-.16615 0-.30263-.02948-.40944-.08843-.10681-.05895-.16022-.13427-.16022-.22597v-.786c0-.0917.05341-.16702.16022-.22597s.2433-.08842.40944-.08842h10.65822c.16615 0 .30263.02947.40944.08842.10681.05895.16022.13428.16022.22598v.78599c0 .0917-.0534.16702-.16022.22597-.1068.05895-.24329.08843-.40944.08843H9.77212ZM5.74153 8.41355l-.48956.50107c-.08703.06263-.18494.09395-.29373.09395-.1088 0-.2067-.03132-.29374-.09395L3.13055 7.4114C3.04352 7.34877 3 7.26526 3 7.16087c0-.1044.03264-.19834.09791-.28185l.5222-.46976c.08703-.08351.18494-.12527.29373-.12527.1088 0 .19583.04176.2611.12527l.75066.68898 2.08878-2.00429C7.07966 5.03132 7.1667 5 7.27548 5c.1088 0 .2067.03132.29374.09395l.55483.53239c.06528.08351.09791.17224.09791.2662 0 .09394-.04351.18267-.13054.26619h.03263L5.74153 8.41355Zm0 5.0107-.48956.46976c-.08703.08351-.18494.12527-.29373.12527-.1088 0-.2067-.04176-.29374-.12527l-1.53395-1.4719C3.04352 12.33862 3 12.24988 3 12.15593c0-.09395.03264-.18268.09791-.2662l.5222-.50106c.08703-.06264.18494-.09395.29373-.09395.1088 0 .19583.03131.2611.09395l.75066.68897 2.08878-1.97297c.06528-.08351.15231-.12527.2611-.12527.1088 0 .2067.04176.29374.12527l.55483.53239c.06528.06263.09791.14615.09791.25054 0 .10438-.04351.19834-.13054.28185h.03263l-2.38252 2.25482Zm0 4.98073-.48956.46975C5.16494 18.95824 5.06703 19 4.95824 19c-.1088 0-.2067-.04176-.29374-.12527l-1.53395-1.4719C3.04352 17.31934 3 17.2306 3 17.13665c0-.09395.03264-.18268.09791-.2662l.5222-.50106c.08703-.06264.18494-.09395.29373-.09395.1088 0 .19583.03131.2611.09395l.75066.68897 2.08878-1.97297c.06528-.08351.15231-.12527.2611-.12527.1088 0 .2067.04176.29374.12527l.55483.53239c.06528.06263.09791.14615.09791.25054 0 .10439-.04351.19834-.13054.28185h.03263l-2.38252 2.25482Z"
      fill="#0F2643"
      fillRule="nonzero"
      opacity=".5"
    />
  </svg>
);

export const HitRateIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={cn('cb-icon icon-hit_rate', className)}
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M11.65517 2.6896a9.56082 9.56082 0 0 1 2.65424.37179.68995.68995 0 1 1-.3839 1.32543 8.15904 8.15904 0 0 0-2.27034-.3179c-4.57063 0-8.27586 3.70524-8.27586 8.27587 0 4.57063 3.70523 8.27586 8.27586 8.27586 4.57063 0 8.27586-3.70523 8.27586-8.27586a.68926.68926 0 0 1 .68966-.68966.68926.68926 0 0 1 .48778.20188.6897.6897 0 0 1 .20187.48778c0 5.3324-4.32276 9.65517-9.65517 9.65517C6.32277 21.99996 2 17.6772 2 12.3448S6.32277 2.6896 11.65517 2.6896Zm0 2.75863a6.7843 6.7843 0 0 1 1.89586.26873.6891.6891 0 0 1 .46945.85466.68788.68788 0 0 1-.85467.46942 5.42552 5.42552 0 0 0-1.51064-.2135c-3.04709 0-5.51724 2.47016-5.51724 5.51725s2.47015 5.51724 5.51724 5.51724c3.0471 0 5.51724-2.47015 5.51724-5.51724 0-.38089.30877-.68966.68966-.68966.38088 0 .68965.30877.68965.68966 0 3.80886-3.08769 6.89655-6.89655 6.89655-3.80886 0-6.89655-3.0877-6.89655-6.89655 0-3.80886 3.0877-6.89656 6.89655-6.89656ZM8.23815 10.0096c1.00322-1.46807 2.83212-2.13116 4.5431-1.64717.36459.10244.57837.47971.47888.84512-.0995.3654-.47502.58223-.84122.4857-1.14012-.32849-2.36256.10884-3.0356 1.08598-.67303.97713-.64587 2.27517.06745 3.2233.71333.94812 1.953 1.33393 3.07838.95803 1.12537-.3759 1.88433-1.42928 1.88465-2.61577 0-.38089.30877-.68966.68966-.68966.38088 0 .68965.30877.68965.68966-.00014 1.77811-1.13615 3.35737-2.8219 3.92298-1.68576.5656-3.5444-.00888-4.61697-1.42708-1.07258-1.41819-1.11931-3.36302-.11608-4.83109Zm9.82599-7.80757c.19721-.19724.49383-.25626.75152-.14953.2577.10674.42572.3582.42572.63712v2.06896h2.06896a.68993.68993 0 0 1 .61692.3812.68948.68948 0 0 1-.06533.72198l-2.06896 2.75862a.6893.6893 0 0 1-.5516.27613h-3.1627l-3.93591 3.93586a.68958.68958 0 1 1-.97517-.9752l3.93586-3.93587V5.44824a.68916.68916 0 0 1 .20207-.48759Zm-.20207 2.15245L16.48276 5.7338v1.7834h2.4138l1.03447-1.3793h-1.3793a.68926.68926 0 0 1-.68966-.68966V4.35448Z"
      fill="#515A6F"
      fillRule="nonzero"
      opacity=".5"
    />
  </svg>
);

export const QuestionMarkIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={cn('cb-icon icon-question-mark', className)}
    xmlns={xmlns}
    {...rest}
  >
    <path
      fill="#515B6E"
      d="M11.95 18Q12.475 18 12.838 17.637Q13.2 17.275 13.2 16.75Q13.2 16.225 12.838 15.863Q12.475 15.5 11.95 15.5Q11.425 15.5 11.062 15.863Q10.7 16.225 10.7 16.75Q10.7 17.275 11.062 17.637Q11.425 18 11.95 18ZM11.05 14.15H12.9Q12.9 13.325 13.088 12.85Q13.275 12.375 14.15 11.55Q14.8 10.9 15.175 10.312Q15.55 9.725 15.55 8.9Q15.55 7.5 14.525 6.75Q13.5 6 12.1 6Q10.675 6 9.788 6.75Q8.9 7.5 8.55 8.55L10.2 9.2Q10.325 8.75 10.763 8.225Q11.2 7.7 12.1 7.7Q12.9 7.7 13.3 8.137Q13.7 8.575 13.7 9.1Q13.7 9.6 13.4 10.037Q13.1 10.475 12.65 10.85Q11.55 11.825 11.3 12.325Q11.05 12.825 11.05 14.15ZM12 22Q9.95 22 8.125 21.212Q6.3 20.425 4.938 19.075Q3.575 17.725 2.788 15.9Q2 14.075 2 12Q2 9.925 2.788 8.1Q3.575 6.275 4.938 4.925Q6.3 3.575 8.125 2.787Q9.95 2 12 2Q14.1 2 15.925 2.787Q17.75 3.575 19.1 4.925Q20.45 6.275 21.225 8.1Q22 9.925 22 12Q22 14.075 21.225 15.9Q20.45 17.725 19.1 19.075Q17.75 20.425 15.925 21.212Q14.1 22 12 22ZM12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12ZM12 20Q15.35 20 17.675 17.663Q20 15.325 20 12Q20 8.675 17.675 6.337Q15.35 4 12 4Q8.725 4 6.362 6.337Q4 8.675 4 12Q4 15.325 6.362 17.663Q8.725 20 12 20Z"
    />
  </svg>
);

export const RightArrow: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="16"
    height="16"
    className={cn('right-arrow', className)}
    xmlns={xmlns}
    {...rest}
  >
    <path
      d="M4.849 1.825a1.14 1.14 0 0 0 .007 1.643l4.747 4.534-4.747 4.53a1.14 1.14 0 0 0-.007 1.643c.474.46 1.227.463 1.704.006L13 8.002 6.552 1.82a1.226 1.226 0 0 0-1.703.006Z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export const NoOpportunities: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="47"
    height="44"
    className={cn('icon-no-opportunities', className)}
    xmlns={xmlns}
    {...rest}
  >
    <g fill="none">
      <path
        fill="#515B6E"
        d="m0 28.339 11.072-11.627A2.277 2.277 0 0 1 12.721 16h21.558c.621 0 1.215.257 1.649.712L47 28.339v11.882C47 42.308 45.35 44 43.314 44H3.686C1.65 44 0 42.308 0 40.221V28.34Z"
      />
      <path
        fill="#515B6E"
        d="M2 29h11.297c0 3.336 2.577 6.041 5.757 6.041h8.892c3.18 0 5.757-2.705 5.757-6.041H45v10.706C45 40.973 44.021 42 42.814 42H4.186C2.98 42 2 40.973 2 39.706V29Z"
      />
      <path
        fill="#FED400"
        d="M24 11.96c0 .574-.448 1.04-1 1.04s-1-.466-1-1.04V1.04C22 .466 22.448 0 23 0s1 .466 1 1.04v10.92Z"
      />
      <path
        fill="#E3482F"
        d="M18.19 11.648c.128.515-.203 1.04-.738 1.174-.536.133-1.075-.175-1.203-.69l-2.439-9.78c-.128-.515.203-1.04.738-1.174.536-.133 1.075.175 1.203.69l2.439 9.78Z"
      />
      <path
        fill="#96B89E"
        d="M29.751 12.132c-.128.515-.667.823-1.203.69-.535-.134-.866-.66-.738-1.174l2.439-9.78c.128-.515.667-.823 1.203-.69.535.134.866.66.738 1.174l-2.439 9.78Z"
      />
      <path
        fill="#FFF"
        d="M5 26.485 13.293 18h20.414L42 26.485H31.368V28.2c0 2.099-1.714 3.8-3.828 3.8h-8.08c-2.114 0-3.828-1.701-3.828-3.8v-1.715H5Z"
      />
    </g>
  </svg>
);

export const ThumbUp: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="30"
    height="30"
    className={cn('icon-thumb-up', className)}
    xmlns={xmlns}
    {...rest}
  >
    <g fillRule="nonzero" fill="none">
      <path
        d="M24.2 14.67647c0-.30383-.07196-.58894-.1925-.84807-.80414-2.6131-4.56882-2.42222-9.92381-2.54967-.8953-.02114-.38318-1.08607-.06896-3.42372C14.2192 6.33463 13.24596 4 11.61008 4c-2.69728 0-.10254 2.14315-2.4874 7.44303C7.8484 14.27478 5 12.68857 5 15.533v6.47474c0 1.10721.10794 2.17154 1.65387 2.34671C8.15243 24.5242 7.81542 25.6 9.9772 25.6h10.82031c1.10218 0 1.99868-.90365 1.99868-2.01388 0-.46028-.16011-.87949-.41856-1.21896.61165-.34491 1.03141-.99607 1.03141-1.75112 0-.45908-.1595-.87828-.41736-1.21715.61345-.3443 1.03442-.99607 1.03442-1.75233 0-.54908-.22068-1.04681-.57628-1.41105.45395-.36907.75018-.9272.75018-1.55904Z"
        fill="#E5BEC0"
      />
      <path
        d="M16.6591 16.78416h5.00325c.68036 0 1.31885-.37415 1.6666-.97602.14304-.24804.06338-.569-.17853-.71662-.24132-.14763-.55359-.06455-.69722.18349-.16457.28629-.4687.4632-.79143.4632h-5.12304c-.50765 0-.92052-.42435-.92052-.94613s.41287-.94613.92052-.94613h3.42331c.28087 0 .50882-.2343.50882-.52298S20.2429 12.8 19.96204 12.8h-3.42389c-1.0688 0-1.93815.89354-1.93815 1.99208 0 .61263.27621 1.15473.70071 1.5205-.35762.3616-.58034.86366-.58034 1.41831 0 .61442.27796 1.15831.70478 1.5235-.3553.361-.57569.86126-.57569 1.41472 0 .6694.32506 1.25991.81934 1.62151-.3047.35204-.49544.81046-.49544 1.3173 0 1.09854.86935 1.99208 1.93815 1.99208h3.18896c.68036 0 1.31944-.37355 1.66717-.97542.14364-.24804.06397-.569-.17735-.71662-.24191-.14644-.55418-.06575-.69723.18229-.16573.2863-.46985.4638-.79259.4638h-3.18896c-.50765 0-.92052-.42435-.92052-.94613s.41287-.94613.92052-.94613h3.78326c.68036 0 1.32001-.37415 1.66717-.97602.14363-.24864.06397-.5696-.17736-.71663-.24365-.15001-.55475-.06574-.69722.1823-.16805.29107-.46462.4644-.79259.4644h-4.10716c-.50765 0-.92051-.42495-.92051-.94673 0-.52178.41286-.94614.92051-.94614h4.70495c.68035 0 1.31943-.37355 1.66717-.97542.14363-.24804.06396-.569-.17736-.71662-.24249-.14703-.55418-.06575-.69723.1823-.16805.29047-.46462.4638-.79258.4638H16.6591c-.50765 0-.92052-.42436-.92052-.94614 0-.52178.41229-.94673.92052-.94673Z"
        fill="#FFF"
      />
    </g>
  </svg>
);

export const TrophyIcon: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="75px"
    height="117px"
    xmlns={xmlns}
    className={cn('icon-trophy', className)}
    viewBox="0 0 75 117"
    {...rest}
  >
    <defs>
      <linearGradient
        x1="63.0042033%"
        y1="18.6620428%"
        x2="33.5019333%"
        y2="100%"
        id="linearGradient-1"
      >
        <stop stopColor="#B78628" offset="0%" />
        <stop stopColor="#FCC201" offset="28.6195468%" />
        <stop stopColor="#DBA514" offset="64.4186044%" />
        <stop stopColor="#FCC201" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="79.842124%"
        y1="18.6620428%"
        x2="12.1401372%"
        y2="100%"
        id="linearGradient-2"
      >
        <stop stopColor="#B78628" offset="0%" />
        <stop stopColor="#FCC201" offset="28.6195468%" />
        <stop stopColor="#DBA514" offset="64.4186044%" />
        <stop stopColor="#FCC201" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="63.0038589%"
        y1="18.6620428%"
        x2="33.5023703%"
        y2="100%"
        id="linearGradient-3"
      >
        <stop stopColor="#B78628" offset="0%" />
        <stop stopColor="#FCC201" offset="28.6195468%" />
        <stop stopColor="#DBA514" offset="64.4186044%" />
        <stop stopColor="#FCC201" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="85.7579556%"
        y1="43.98656%"
        x2="4.63488815%"
        y2="59.594499%"
        id="linearGradient-4"
      >
        <stop stopColor="#B78628" offset="0%" />
        <stop stopColor="#FCC201" offset="28.6195468%" />
        <stop stopColor="#DBA514" offset="64.4186044%" />
        <stop stopColor="#FCC201" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="85.7579556%"
        y1="49.5070612%"
        x2="4.63488815%"
        y2="50.7864885%"
        id="linearGradient-5"
      >
        <stop stopColor="#B78628" offset="0%" />
        <stop stopColor="#FCC201" offset="28.6195468%" />
        <stop stopColor="#DBA514" offset="64.4186044%" />
        <stop stopColor="#FCC201" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Group">
      <path
        fill="#96B8B2"
        d="m44.516 50.686-3.138.895 1.284-3.133-1.718-2.825 3.22.242 2.075-2.642.707 3.285 3.001 1.192-2.783 1.787-.221 3.379z"
      />
      <path
        d="M18.558,75.8960526 C19.328,77.5894737 20.252,79.1289474 21.33,80.5144737 C3.312,77.7434211 0.848,60.5013158 0.54,52.9578947 C0.386,49.2631579 3.312,46.0302632 7.162,46.0302632 C10.858,46.0302632 13.784,48.9552632 13.784,52.65 L13.784,52.9578947 L14.246,52.9578947 C14.246,54.0355263 14.246,55.4210526 14.246,56.8065789 L11.936,56.8065789 C10.858,56.8065789 9.934,56.0368421 9.934,54.8052632 L9.934,52.65 C9.934,51.1105263 8.702,49.8789474 7.162,49.8789474 C5.468,49.8789474 4.236,51.2644737 4.39,52.8039474 C4.698,60.1934211 6.854,72.2013158 18.558,75.8960526 Z"
        fill="url(#linearGradient-1)"
      />
      <path
        d="M41.504,86.3644737 L41.504,96.6789474 L33.496,96.6789474 L33.496,86.3644737 C16.402,82.9776316 15.632,59.7315789 15.786,51.7263158 C15.786,50.1868421 17.018,49.1092105 18.558,49.1092105 L56.442,49.1092105 C57.982,49.1092105 59.06,50.3407895 59.214,51.7263158 C59.368,59.7315789 58.598,82.9776316 41.504,86.3644737 Z"
        fill="url(#linearGradient-2)"
      />
      <path
        d="M74.46,52.9578947 C74.152,60.5013158 71.688,77.7434211 53.67,80.5144737 C54.748,79.1289474 55.672,77.5894737 56.442,75.8960526 C68.146,72.2013158 70.456,60.3473684 70.61,52.8039474 C70.61,51.2644737 69.378,49.8789474 67.838,49.8789474 C66.298,49.8789474 65.066,51.1105263 65.066,52.65 L65.066,54.9592105 C65.066,56.0368421 64.142,56.9605263 63.064,56.9605263 L60.6,56.9605263 C60.6,55.575 60.6,54.1894737 60.6,53.1118421 L61.062,53.1118421 L61.062,52.65 C61.062,48.9552632 63.988,46.0302632 67.684,46.0302632 C71.534,46.0302632 74.614,49.1092105 74.46,52.9578947 Z"
        fill="url(#linearGradient-3)"
      />
      <path
        d="M51.206,100.373684 L51.206,110.226316 L23.794,110.226316 L23.794,100.373684 C23.794,99.1421053 24.718,98.2184211 25.95,98.2184211 L48.896,98.2184211 C50.282,98.2184211 51.206,99.2960526 51.206,100.373684 Z"
        fill="url(#linearGradient-4)"
      />
      <path
        d="M55.056,111.765789 L18.558,111.765789 C17.018,111.765789 15.94,112.997368 15.94,114.382895 C15.94,115.922368 17.172,117 18.558,117 L55.056,117 C56.596,117 57.674,115.768421 57.674,114.382895 C57.674,112.997368 56.442,111.765789 55.056,111.765789 Z"
        fill="url(#linearGradient-5)"
      />
      <path
        fill="#FFF"
        d="m37.5 70.816-5.431 2.854 1.037-6.045-4.394-4.282 6.072-.882 2.716-5.5 2.716 5.5 6.072.882-4.394 4.282 1.037 6.045z"
      />
      <path
        fill="#FED400"
        d="m26.72 39.257-2.716 1.427.519-3.023-2.197-2.141 3.036-.441 1.358-2.75 1.358 2.75 3.036.441-2.197 2.141.519 3.023z"
      />
      <path
        fill="#FB9337"
        d="m42.12 31.559-2.716 1.427.519-3.022-2.197-2.141 3.036-.441 1.358-2.75 1.358 2.75 3.036.441-2.197 2.141.519 3.022z"
      />
      <path
        fill="#00397D"
        d="m32.88 6.928-2.716 1.427.519-3.023-2.197-2.141 3.036-.441L32.88 0l1.358 2.75 3.036.441-2.197 2.141.519 3.023z"
      />
      <path
        fill="#E3482F"
        d="m51.36 16.164-2.716 1.428.519-3.023-2.197-2.141 3.036-.441 1.358-2.75 1.358 2.75 3.036.441-2.197 2.141.519 3.023z"
      />
    </g>
  </svg>
);

export const GoldMedal: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="30"
    height="30"
    className={cn('icon-gold-medal', className)}
    xmlns={xmlns}
    {...rest}
  >
    <defs>
      <linearGradient id="linearA" x1="82.09301%" y1="18.66204%" x2="9.2845%" y2="100%">
        <stop stopColor="#B78628" offset="0%" />
        <stop stopColor="#FCC201" offset="28.61955%" />
        <stop stopColor="#DBA514" offset="64.4186%" />
        <stop stopColor="#FCC201" offset="100%" />
      </linearGradient>
      <linearGradient id="linearB" x1="85.75796%" y1="24.10086%" x2="4.63489%" y2="91.32231%">
        <stop stopColor="#FCC201" offset="0%" />
        <stop stopColor="#DBA514" offset="40.18951%" />
        <stop stopColor="#FCC201" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h30v30H0z" />
      <g fillRule="nonzero">
        <path fill="#D8E5E3" d="M14.81133 6.58824 9.05137 0H0l11.51992 14L20 10z" />
        <path fill="#96B8B2" d="M19.83333 0 14 6.26959 18.49167 12l1.0225-1.16693L29 0z" />
        <path
          d="M19.38905 13.25733c.0675-.18189.11053-.37552.11053-.58088 0-.9254-.75598-1.67645-1.68745-1.67645h-5.6251c-.93232 0-1.68745.75105-1.68745 1.67645 0 .20536.04218.39899.11053.58088C7.86125 14.78793 6 17.70578 6 21.05868 6 25.99665 10.02878 30 15 30c4.97038 0 9-4.00335 9-8.94132-.00084-3.3529-1.86125-6.27075-4.61095-7.80135Z"
          fill="url(#linearA)"
        />
        <circle fill="#FFD983" cx="15" cy="21" r="7" />
        <path
          d="M18.50393 26a.66343.66343 0 0 1-.37213-.11411l-2.63245-1.79356-2.63153 1.79356c-.22457.15244-.52521.15244-.74794-.00261-.22273-.15331-.31623-.42596-.23373-.67422l.98167-3.01045-2.6077-1.74652c-.22182-.15505-.31348-.42857-.22915-.6777.08524-.24826.32814-.41725.60403-.41899l3.23007-.00435 1.02841-2.93554c.08708-.24826.3309-.41551.60679-.41551.27497 0 .5197.16725.60678.4155l1.011 2.93555 3.24656.00435c.2759.00174.51971.17073.60404.41899.08524.24913-.00733.52178-.22915.6777l-2.60862 1.74652.98167 3.01045c.08433.24913-.011.5209-.23281.67422-.11274.0784-.24473.11672-.3758.11672Z"
          fill="url(#linearB)"
        />
      </g>
    </g>
  </svg>
);

export const BronzeMedal: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="30"
    height="30"
    className={cn('icon-bronze-medal', className)}
    xmlns={xmlns}
    {...rest}
  >
    <defs>
      <linearGradient
        id="linearGradient-1"
        x1="94.8753463%"
        y1="13.4783959%"
        x2="5.12465374%"
        y2="100%"
      >
        <stop stopColor="#EDB89A" offset="0%" />
        <stop stopColor="#DA8B6B" offset="28.6648193%" />
        <stop stopColor="#EEC4B3" offset="55.9080431%" />
        <stop stopColor="#D68261" offset="100%" />
      </linearGradient>
      <linearGradient id="linearGradient-2" x1="100%" y1="19.8168561%" x2="0%" y2="91.322314%">
        <stop stopColor="#EDB89A" offset="0%" />
        <stop stopColor="#DA8B6B" offset="50.483386%" />
        <stop stopColor="#D68261" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Assets" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-3697.000000, -308.000000)"
        fillRule="nonzero"
        id="Illustration/medal/bronze"
      >
        <g transform="translate(3697.000000, 308.000000)">
          <path
            d="M15.8113318,6.58823529 L10.0513695,0 L1,0 L12.5199248,14 C17.7111205,12.3741122 20.5378122,11.0407789 21,10 C21.4621878,8.95922113 19.7326317,7.82196623 15.8113318,6.58823529 Z"
            id="Path"
            fill="#D8E5E3"
          />
          <polygon
            id="Path"
            fill="#96B8B2"
            points="20.8333333 0 15 6.26959248 19.4916667 12 20.5141667 10.8330721 30 0"
          />
          <path
            d="M20.3890503,13.2573345 C20.4565482,13.0754401 20.4995781,12.8818106 20.4995781,12.6764459 C20.4995781,11.7510478 19.7436018,11 18.8121309,11 L13.1870254,11 C12.2547108,11 11.4995781,11.7510478 11.4995781,12.6764459 C11.4995781,12.8818106 11.5417643,13.0754401 11.6101059,13.2573345 C8.86125434,14.7879296 7,17.7057837 7,21.0586756 C7,25.9966471 11.0287804,30 16,30 C20.9703759,30 25,25.9966471 25,21.0586756 C24.9991563,17.7057837 23.1387457,14.7879296 20.3890503,13.2573345 Z"
            id="Path"
            fill="url(#linearGradient-1)"
          />
          <circle id="Oval" fill="#F8D2C3" cx="16" cy="21" r="7" />
          <path
            d="M19.5039345,26 C19.3737786,26 19.2436226,25.9616725 19.1317985,25.8858885 L16.4993489,24.0923345 L13.8678159,25.8858885 C13.6432511,26.0383275 13.3426092,26.0383275 13.1198776,25.8832753 C12.897146,25.7299652 12.8036537,25.4573171 12.8861469,25.2090592 L13.8678159,22.1986063 L11.2601143,20.4520906 C11.0382993,20.2970383 10.9466401,20.0235192 11.0309665,19.7743902 C11.1162095,19.5261324 11.3591061,19.3571429 11.635,19.3554007 L14.865067,19.3510453 L15.8934822,16.4155052 C15.9805584,16.1672474 16.2243716,16 16.5002655,16 C16.7752428,16 17.0199727,16.1672474 17.1070488,16.4155052 L18.1180488,19.3510453 L21.3646144,19.3554007 C21.6405083,19.3571429 21.8843215,19.5261324 21.9686479,19.7743902 C22.0538909,20.0235192 21.9613152,20.2961672 21.7395002,20.4520906 L19.1308819,22.1986063 L20.112551,25.2090592 C20.1968774,25.4581882 20.1015519,25.7299652 19.8797368,25.8832753 C19.7669961,25.9616725 19.635007,26 19.5039345,26 Z"
            id="Path"
            fill="url(#linearGradient-2)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const SilverMedal: FC<IconProps> = ({ className, ...rest }: IconProps) => (
  <svg
    role="img"
    width="30"
    height="30"
    className={cn('icon-silver-medal', className)}
    xmlns={xmlns}
    {...rest}
  >
    <defs>
      <linearGradient
        id="linearGradient1"
        x1="100.368809%"
        y1="14.2266678%"
        x2="5.12465374%"
        y2="88.8361363%"
      >
        <stop stopColor="#E2E2E2" offset="0%" />
        <stop stopColor="#C8C8C8" offset="33.09599%" />
        <stop stopColor="#E6E6E6" offset="62.3695507%" />
        <stop stopColor="#C1C1C1" offset="100%" />
      </linearGradient>
      <linearGradient
        id="linearGradient2"
        x1="106.120803%"
        y1="20.4352626%"
        x2="0%"
        y2="82.0959804%"
      >
        <stop stopColor="#E2E2E2" offset="0%" />
        <stop stopColor="#C8C8C8" offset="50.548243%" />
        <stop stopColor="#C1C1C1" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Assets" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-3837.000000, -308.000000)"
        fillRule="nonzero"
        id="Illustration/medal/silver"
      >
        <g transform="translate(3837.000000, 308.000000)">
          <path
            d="M15.8113318,6.58823529 L10.0513695,0 L1,0 L12.5199248,14 C17.0444538,12.3741122 19.5378122,11.0407789 20,10 C20.4621878,8.95922113 19.065965,7.82196623 15.8113318,6.58823529 Z"
            id="Path"
            fill="#D8E5E3"
          />
          <polygon
            id="Path"
            fill="#96B8B2"
            points="20.8333333 0 15 6.26959248 19.4916667 12 20.5141667 10.8330721 30 0"
          />
          <path
            d="M20.3890503,13.2573345 C20.4565482,13.0754401 20.4995781,12.8818106 20.4995781,12.6764459 C20.4995781,11.7510478 19.7436018,11 18.8121309,11 L13.1870254,11 C12.2547108,11 11.4995781,11.7510478 11.4995781,12.6764459 C11.4995781,12.8818106 11.5417643,13.0754401 11.6101059,13.2573345 C8.86125434,14.7879296 7,17.7057837 7,21.0586756 C7,25.9966471 11.0287804,30 16,30 C20.9703759,30 25,25.9966471 25,21.0586756 C24.9991563,17.7057837 23.1387457,14.7879296 20.3890503,13.2573345 Z"
            id="Path"
            fill="url(#linearGradient1)"
          />
          <circle id="Oval" fill="#ECECEC" cx="16" cy="21" r="7" />
          <path
            d="M19.5039345,26 C19.3737786,26 19.2436226,25.9616725 19.1317985,25.8858885 L16.4993489,24.0923345 L13.8678159,25.8858885 C13.6432511,26.0383275 13.3426092,26.0383275 13.1198776,25.8832753 C12.897146,25.7299652 12.8036537,25.4573171 12.8861469,25.2090592 L13.8678159,22.1986063 L11.2601143,20.4520906 C11.0382993,20.2970383 10.9466401,20.0235192 11.0309665,19.7743902 C11.1162095,19.5261324 11.3591061,19.3571429 11.635,19.3554007 L14.865067,19.3510453 L15.8934822,16.4155052 C15.9805584,16.1672474 16.2243716,16 16.5002655,16 C16.7752428,16 17.0199727,16.1672474 17.1070488,16.4155052 L18.1180488,19.3510453 L21.3646144,19.3554007 C21.6405083,19.3571429 21.8843215,19.5261324 21.9686479,19.7743902 C22.0538909,20.0235192 21.9613152,20.2961672 21.7395002,20.4520906 L19.1308819,22.1986063 L20.112551,25.2090592 C20.1968774,25.4581882 20.1015519,25.7299652 19.8797368,25.8832753 C19.7669961,25.9616725 19.635007,26 19.5039345,26 Z"
            id="Path"
            fill="url(#linearGradient2)"
          />
        </g>
      </g>
    </g>
  </svg>
);
